<div class="ng-Header col-xs-12">
  <i nz-icon nzType="form" nzTheme="outline"></i> Schedule Inspection
</div>
<div class="searchboxAerar p-3">
  <form nz-form [formGroup]="scheduleInspectionForm" (ngSubmit)="submitForm()">
    <div class="form-row" style="margin-left: 12px">
      <div class="form-group col-md-3">
        <nz-form-label style="margin-left: 15px">Name of STP/SAC</nz-form-label>
        <div class="form-group col-md-12">
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="stpOrSacNameErrorTpl"
            >
              <input
                nz-input
                formControlName="stpOrSacName"
                placeholder="Name of STP Or SAC"
                readonly
              />
              <ng-template #stpOrSacNameErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input valid name!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="form-group col-md-3">
        <div class="form-group col-md-12">
          <nz-form-label [nzSpan]="null">STP/SAC ID</nz-form-label>
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="stpOrSacIdErrorTpl"
            >
              <input
                nz-input
                formControlName="stpOrSacId"
                placeholder="STP or SAC ID"
                nzAutosize
                readonly
              />
              <ng-template #stpOrSacIdErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input valid STP Or SAC ID!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="form-group col-md-3">
        <div class="form-group col-md-12">
          <nz-form-label [nzSpan]="null">Address of STP/SAC</nz-form-label>
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="addressOfSTPOrSACErrorTpl"
            >
              <input
                nz-input
                type="text"
                formControlName="addressofStpOrSac"
                placeholder="Address of STP Or SAC"
                readonly
              />
              <ng-template #addressOfSTPOrSACErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input Address of STP Or SAC!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="form-group col-md-3">
        <div class="form-group col-md-12">
          <nz-form-label>District</nz-form-label>
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="districtErrorTpl"
            >
              <input
                nz-input
                type="text"
                formControlName="district"
                placeholder="District"
                readonly
              />
              <ng-template #districtErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input District!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>
    <!-- <div class="form-row" style="margin-left: 12px">
      <div class="form-group col-md-3">
        <nz-form-label style="margin-left: 15px"
          >Application ID</nz-form-label
        >
        <div class="form-group col-md-12">
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="applicationIdErrorTpl"
            >
              <input
                nz-input
                formControlName="applicationId"
                placeholder="Application Id"
                readonly
              />
              <ng-template #applicationIdErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input valid application Id!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="form-group col-md-3">
        <nz-form-label style="margin-left: 15px"
          >Date of Application</nz-form-label
        >
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="dateOfApplicationErrorTpl"
            >
              <nz-date-picker
                id="DateOfApplication"
                formControlName="DateOfApplication"
                placeholder="Date of Application"
                style="width: 100%"
                nzDisabled
              >
              </nz-date-picker>
              <ng-template #dateOfApplicationErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input valid Date of Application!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div> -->
    <hr />
    <!-- <b style="margin-left: 10px">List of Occupations</b>
    <hr />
    <div class="form-row" style="margin-left: 12px">
      <nz-table
        #basicTable
        [nzData]="listOfOccupation"
        nzTableLayout="fixed"
        nzShowSizeChanger
        nzBordered
        nzSize="middle"
        nzAlign="middle"
        [nzFrontPagination]="false"
      >
        <thead>
          <tr>
            <th>Name of Occupation & Level</th>
            <th>Application Type</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data; let i = index">
            <td>
              {{ data.occupationName }}, Level-{{ data.occupationLevel }}
            </td>
            <td>{{ data.applicationType }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>
    <hr /> -->
    <b style="margin-left: 10px">Payment Information</b>
    <hr />
    <div class="form-row" style="margin-left: 12px">
      <div class="form-group col-md-3">
        <nz-form-label style="margin-left: 15px"
          >Amount Paid (in BDT)</nz-form-label
        >
        <div class="form-group col-md-12">
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="amountErrorTpl"
            >
              <input
                nz-input
                type="number"
                min="0"
                formControlName="amount"
                placeholder="Amount"
                readonly
              />
              <ng-template #amountErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input amount!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="form-group col-md-3">
        <nz-form-label style="margin-left: 15px">Date of Payment</nz-form-label>
        <div class="form-group col-md-12">
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="dateOfPaymentErrorTpl"
            >
              <nz-date-picker
                id="DateofPayment"
                formControlName="DateofPayment"
                placeholder="Date of Payment"
                style="width: 100%"
                nzDisabled
              >
              </nz-date-picker>
              <ng-template #dateOfPaymentErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input valid Date of Payment!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="form-group col-md-3">
        <nz-form-label style="margin-left: 15px">Bank Name</nz-form-label>
        <div class="form-group col-md-12">
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="bankNameErrorTpl"
            >
              <input
                nz-input
                formControlName="bankName"
                placeholder="Bank Name"
                readonly
              />
              <ng-template #bankNameErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input valid Bank name!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <!-- <div class="form-group col-md-3">
        <nz-form-label
          [nzRequired]="scheduleInspection?.paymentTypeId == 2 ? true : false"
          style="margin-left: 15px"
          >Payment Proof</nz-form-label
        >
        <div class="form-group col-md-12">
          <button
            *ngIf="
              scheduleInspection?.paymentTypeId == 2 &&
              scheduleInspection?.applicationProof
            "
            (click)="onPaymentProofDownload()"
            nz-button
            nzType="primary"
            type="button"
            style="margin-left: 10px"
          >
            <i nz-icon nzType="download"></i>
          </button>
        </div>
      </div> -->
      <div class="form-group col-md-3">
        <nz-form-label nzRequired style="margin-left: 15px"
          >Payment Verification</nz-form-label
        >
        <div class="form-group col-md-12">
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="paymentVerificationErrorTpl"
            >
              <nz-select
                id="paymentVerification_id"
                nzShowSearch
                nzAllowClear
                formControlName="isPaymentVerified"
                nzPlaceHolder="Select Payment Verification"
                (ngModelChange)="onPaymentVerificationChange($event)"
                nzDisabled
              >
                <nz-option
                  *ngFor="let paymentVerification of paymentVerification"
                  [nzValue]="paymentVerification.id"
                  [nzLabel]="paymentVerification.name"
                >
                </nz-option>
              </nz-select>
              <ng-template #paymentVerificationErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input payment Verification!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <app-stp-action-history
        *ngIf="stpMainId && applicationId"
        [stpMainId]="stpMainId"
        [applicationId]="applicationId"
      ></app-stp-action-history>
      <div
        class="form-group col-md-3"
        *ngIf="scheduleInspectionForm.get('isPaymentVerified')?.value == false"
      >
        <nz-form-label nzRequired style="margin-left: 15px"
          >Reason If Failed</nz-form-label
        >
        <div class="form-group col-md-12">
          <nz-form-item>
            <nz-form-control
              [nzSpan]="null"
              nzHasFeedback
              [nzErrorTip]="reasonErrorTpl"
            >
              <input
                nz-input
                formControlName="paymentFailedReason"
                placeholder="Reason"
              />
              <ng-template #reasonErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please input reason!
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>
    <div *ngIf="scheduleInspectionForm.get('isPaymentVerified')?.value == true">
      <hr />
      <b style="margin-left: 10px">Schedule Inspection</b>
      <hr />

      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-4">
          <nz-form-label
            [nzRequired]="scheduleInspection?.isPaymentVerified"
            style="margin-left: 15px"
            >Last Date of Inspection</nz-form-label
          >
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="lastDateErrorTpl"
              >
                <nz-date-picker
                  id="inspectionLastDate"
                  formControlName="inspectionLastDate"
                  placeholder="Last Date"
                  style="width: 100%"
                >
                </nz-date-picker>
                <ng-template #lastDateErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input last date!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-4">
          <nz-form-label
            [nzRequired]="scheduleInspection?.isPaymentVerified"
            style="margin-left: 15px"
            >Representative from NSDA</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="nsdaUserErrorTpl"
              >
                <nz-select
                  id="nsdaUserId"
                  nzShowSearch
                  nzAllowClear
                  formControlName="nsdaUser"
                  nzPlaceHolder="Select Officer"
                  (ngModelChange)="onSelectNSDAOfficer($event)"
                >
                  <nz-option
                    *ngFor="let officer of users"
                    [nzValue]="officer.id"
                    [nzLabel]="officer.name"
                  >
                  </nz-option>
                </nz-select>
                <ng-template #nsdaUserErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input name of assigned representative from NSDA!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label
            [nzRequired]="scheduleInspection?.isPaymentVerified"
            style="margin-left: 15px"
            >Contact</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="contactNSDAOfficerErrorTpl"
              >
                <input
                  readonly
                  nz-input
                  formControlName="contactNSDAOfficer"
                  placeholder="Contact NSDA Officer"
                />
                <ng-template #contactNSDAOfficerErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input contact NSDA officer!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label
            [nzRequired]="scheduleInspection?.isPaymentVerified"
            style="margin-left: 15px"
            >Email</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="emailNSDAOfficerErrorTpl"
              >
                <input
                  readonly
                  nz-input
                  formControlName="emailNSDAOfficer"
                  placeholder="Email for NSDA officer"
                />
                <ng-template #emailNSDAOfficerErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input email for NSDA officer!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        .
      </div>
      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-4">
          <nz-form-label style="margin-left: 15px"
            >Representative from ISC/Industry Association</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="iscOrIndustryOfficerErrorTpl"
              >
                <nz-select
                  id="iscOrIndustryOfficer_id"
                  nzShowSearch
                  nzAllowClear
                  formControlName="inspectorOfficer1"
                  nzPlaceHolder="Select Officer"
                  (ngModelChange)="onSelectOfficer1($event)"
                >
                  <nz-option
                    *ngFor="let officer of inspectionOfficerList"
                    [nzValue]="officer.id"
                    [nzLabel]="officer.name"
                  >
                  </nz-option>
                </nz-select>
                <ng-template #iscOrIndustryOfficerErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input name of assigned representative from
                    ISC/Industry association!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label style="margin-left: 15px">Contact</nz-form-label>
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="contactIscOrIndustryOfficerErrorTpl"
              >
                <input
                  nz-input
                  formControlName="contactIscOrIndustryOfficer"
                  placeholder="Contact Isc Or Industry Officer"
                />
                <ng-template #contactIscOrIndustryOfficerErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input contact NSDA officer!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label style="margin-left: 15px">Email</nz-form-label>
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="emailIscOrIndustryOfficerErrorTpl"
              >
                <input
                  nz-input
                  formControlName="emailIscOrIndustryOfficer"
                  placeholder="Email for Isc Or Industry Officer"
                />
                <ng-template #emailIscOrIndustryOfficerErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input email for Isc Or Industry Officer!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group" style="margin-top: 37px; margin-left: 20px">
          <button
            type="button"
            style="height: 35px"
            class="btn btn-primary"
            (click)="createCustomButtonModal()"
          >
            <i nz-icon nzType="plus" nzTheme="outline"></i>
          </button>
        </div>
      </div>
      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-4">
          <nz-form-label style="margin-left: 15px"
            >Technical Person from Respective Area</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="technicalOfficerErrorTpl"
              >
                <nz-select
                  id="iscOrIndustryOfficer_id"
                  nzShowSearch
                  nzAllowClear
                  formControlName="inspectorOfficer2"
                  nzPlaceHolder="Select Officer"
                  (ngModelChange)="onSelectOfficer2($event)"
                >
                  <nz-option
                    *ngFor="let officer of representativeInspectionOfficerList"
                    [nzValue]="officer.id"
                    [nzLabel]="officer.name"
                  >
                  </nz-option>
                </nz-select>
                <ng-template #technicalOfficerErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input name of assigned technical person from that
                    area!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label style="margin-left: 15px">Contact </nz-form-label>
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="contactTechnicalOfficerErrorTpl"
              >
                <input
                  nz-input
                  formControlName="contactTechnicalOfficer"
                  placeholder="Contact technical Officer from that area"
                />
                <ng-template #contactTechnicalOfficerErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input contact technical officer from that area!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label style="margin-left: 15px">Email</nz-form-label>
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="emailTechnicalOfficerErrorTpl"
              >
                <input
                  nz-input
                  formControlName="emailTechnicalOfficer"
                  placeholder="Email for technical officer from that area"
                />
                <ng-template #emailTechnicalOfficerErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input email for technical officer from that area!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group" style="margin-top: 37px; margin-left: 20px">
          <button
            type="button"
            style="height: 35px"
            class="btn btn-primary"
            (click)="createCustomButtonModal()"
          >
            <i nz-icon nzType="plus" nzTheme="outline"></i>
          </button>
        </div>
      </div>
      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-4">
          <nz-form-label style="margin-left: 15px"
            >Name of Person Assigned by the Executive Chairman</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="executiveChairmanErrorTpl"
              >
                <nz-select
                  id="chairman_id"
                  nzShowSearch
                  nzAllowClear
                  formControlName="inspectorOfficer3"
                  nzPlaceHolder="Select Officer"
                  (ngModelChange)="onSelectOfficer3($event)"
                >
                  <nz-option
                    *ngFor="let officer of technicalInspectionOfficerList"
                    [nzValue]="officer.id"
                    [nzLabel]="officer.name"
                  >
                  </nz-option>
                </nz-select>
                <ng-template #executiveChairmanErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input name of person assigned by the Executive
                    Chairman of NSDA!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label style="margin-left: 15px">Contact</nz-form-label>
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="contactExecutiveChairmanErrorTpl"
              >
                <input
                  nz-input
                  formControlName="contactExecutiveChairman"
                  placeholder="Contact Executive Chairman of NSDA"
                />
                <ng-template #contactExecutiveChairmanErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input contact executive chairman!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label style="margin-left: 15px">Email</nz-form-label>
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="emailExecutiveChairmanErrorTpl"
              >
                <input
                  nz-input
                  formControlName="emailExecutiveChairman"
                  placeholder="Email for technical officer from that area"
                />
                <ng-template #emailExecutiveChairmanErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input email for executive chairman of NSDA!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group" style="margin-top: 37px; margin-left: 20px">
          <button
            type="button"
            style="height: 35px"
            class="btn btn-primary"
            (click)="createCustomButtonModal()"
          >
            <i nz-icon nzType="plus" nzTheme="outline"></i>
          </button>
        </div>
      </div>
      <!-- <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-4">
          <nz-form-label
            [nzRequired]="scheduleInspection?.isPaymentVerified"
            style="margin-left: 15px"
            >Include STP/SAC Registration Application?</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="isRegistrationInspectionRequiredErrorTpl"
              >
                <nz-select
                  id="isRegistrationInspectionRequired_id"
                  nzShowSearch
                  nzAllowClear
                  formControlName="isRegistrationInspectionRequired"
                  nzPlaceHolder="Select One"
                >
                  <nz-option
                    *ngFor="
                      let isRegistrationInspectionRequired of stpSacRegistrationApplication
                    "
                    [nzValue]="isRegistrationInspectionRequired.id"
                    [nzLabel]="isRegistrationInspectionRequired.name"
                  >
                  </nz-option>
                </nz-select>
                <ng-template
                  #isRegistrationInspectionRequiredErrorTpl
                  let-control
                >
                  <ng-container *ngIf="control.hasError('required')">
                    Select One!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div> -->
    </div>
    <div class="row justify-content-center media-button">
      <div class="col-xs-4 col-sm-2 mt-2">
        <button
          type="submit"
          class="btn btn-success active btn-lg btn-block cari border-redius"
          [disabled]="!scheduleInspectionForm.valid || saveButtonDisabled"
        >
          <i nz-icon nzType="save" nzTheme="fill"></i> {{ isScheduleSaved ? 'Update' : 'Save' }}
        </button>
      </div>
      <div class="col-xs-4 col-sm-2 mt-2">
        <button
          type="button"
          class="btn btn-danger active btn-lg btn-block cari border-redius"
          (click)="resetForm()"
        >
          <i nz-icon nzType="redo" nzTheme="outline"></i> Reset
        </button>
      </div>
      <div class="col-xs-4 col-sm-3 mt-2">
        <!-- a disabled button gets no hover, so the tooltip sits on this wrapper -->
        <span
          class="d-block"
          nz-tooltip
          [nzTooltipTitle]="!enableScheduleInspectionButton ? 'Click save/update button first' : null"
        >
          <button
            [disabled]="!enableScheduleInspectionButton || submitButtonDisabled"
            [style.pointer-events]="!enableScheduleInspectionButton || submitButtonDisabled ? 'none' : null"
            type="button"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to submit the inspection schedule?"
            nzPopconfirmPlacement="top"
            nzOkText="Yes"
            nzCancelText="No"
            (nzOnConfirm)="onSubmitStpScheduleInspection()"
          >
            <i nz-icon nzType="save" nzTheme="fill"></i> Submit
          </button>
        </span>
      </div>
    </div>
  </form>
</div>
